import {
  AutocompleteArrayInput,
  Button,
  ReferenceArrayInput,
  required,
  useNotify,
  useRecordContext,
  useRefresh,
} from "react-admin";
import FormModal from "server/components/Modals/FormModal";
import AddIcon from "@mui/icons-material/Add";
import dataProvider from "server/dataProvider";
import { specialistRequests } from "api/specialistApi";

const AddCourseDefinisionsDialog = ({ curriculumId }) => {
  const notify = useNotify();
  const refresh = useRefresh();
  const record = useRecordContext();
  const excludeIds = record?.courses?.map(c => c.definitionId) || [];

  const handleSubmit = async data => {
    await dataProvider.customRequest(
      specialistRequests.addCurriculumCourses(curriculumId),
      { courseDefinitionIds: data.courseDefinitionIds },
      "POST",
    );
    notify("Успешно добавени курсове", { type: "success" });
    refresh();
  };

  return (
    <FormModal
      titleContent="Добави курсове"
      dialogSize="md"
      onConfirm={handleSubmit}
      defaultValues={{ courseDefinitionIds: [] }}
      triggerButton={
        <Button
          label="Добави курсове"
          variant="contained"
          startIcon={<AddIcon />}
          sx={{ mt: 2 }}
        />
      }
    >
      <ReferenceArrayInput
        source="courseDefinitionIds"
        reference={specialistRequests.getPostgraduateCourseDefinitionsSelect()}
        filter={{ filterByUser: true, ExcludeIds: excludeIds }}
      >
        <AutocompleteArrayInput
          label="Дефиниции на курсове"
          optionText={rec => `${rec.name} | ${rec.typeNameBg} | ${rec.clinicNameBg}`}
          validate={[required()]}
          fullWidth
        />
      </ReferenceArrayInput>
    </FormModal>
  );
};

export default AddCourseDefinisionsDialog;
